import * as RadixSwitch from '@radix-ui/react-switch'
import { forwardRef, type ComponentPropsWithoutRef, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Toggle.module.scss'

export interface ToggleProps extends ComponentPropsWithoutRef<typeof RadixSwitch.Root> {
  label?: ReactNode
}

export const Toggle = forwardRef<HTMLButtonElement, ToggleProps>(function Toggle(
  { label, className, id, ...rest },
  ref,
) {
  const root = (
    <RadixSwitch.Root ref={ref} id={id} className={cn(styles.switchRoot, className)} {...rest}>
      <RadixSwitch.Thumb className={styles.switchThumb} />
    </RadixSwitch.Root>
  )

  if (!label) return root

  return (
    <label className={styles.wrap} htmlFor={id}>
      {root}
      <span className={styles.labelText}>{label}</span>
    </label>
  )
})
